// Helpers for the admin result preview. Targets are 0..1 per dimension id (plus "_default" for
// questions without a dimension); the sliders work in whole percentages.

export const DEFAULT_TARGET_KEY = "_default";
export const UNRESOLVED_OUTCOME = "__unresolved__";

export function presetTargets(dimensions = [], level = 0.5) {
  const targets = { [DEFAULT_TARGET_KEY]: level };
  dimensions.forEach((d) => { targets[d.id] = level; });
  return targets;
}

export function levelsFromTargets(targets = {}, dimensions = []) {
  const fallback = targets[DEFAULT_TARGET_KEY] ?? 0.5;
  const levels = { [DEFAULT_TARGET_KEY]: Math.round(fallback * 100) };
  dimensions.forEach((d) => { levels[d.id] = Math.round((targets[d.id] ?? fallback) * 100); });
  return levels;
}

export function targetsFromLevels(levels = {}) {
  return Object.fromEntries(Object.entries(levels).map(([key, value]) => [key, Math.max(0, Math.min(100, Number(value) || 0)) / 100]));
}

export function outcomeLabel(outcome, lang = "id") {
  const id = lang === "id";
  if (outcome.id === UNRESOLVED_OUTCOME) return id ? "Kombinasi belum terkonfigurasi" : "Unconfigured combination";
  const title = (id ? outcome.title_id || outcome.title_en : outcome.title_en || outcome.title_id) || "";
  const key = outcome.result_key || "";
  const base = title && title !== key ? `${key} — ${title}` : key;
  if (outcome.card_match === "exact" || !outcome.card_key) {
    return outcome.card_key ? base : `${base} ${id ? "(belum ada kartu)" : "(no card yet)"}`;
  }
  return `${base} ${id ? `(pakai kartu ${outcome.card_key})` : `(uses card ${outcome.card_key})`}`;
}
